import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { Link, withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';

import { saveContact, updateContact } from './actions';
import Editor from '../../components/common/Editor';
import TextField from '../../components/common/TextField';
import { CONTACT_FORM_NAME } from './constants';

const required = value => (value ? undefined : 'Povinný údaj');

class ContactForm extends Component {
  onSubmit = formProps => {
    const { lang } = formProps;
    const { id } = this.props.initialValues;

    const contactRequestData = {
      title: formProps.title,
      description: formProps.description,
      email: formProps.email,
      telephone: formProps.telephone,
      telephone2: formProps.telephone2,
      address: formProps.address,
      other: formProps.other,
      monday: formProps.monday,
      tuesday: formProps.tuesday,
      wednesday: formProps.wednesday,
      thursday: formProps.thursday,
      friday: formProps.friday,
      saturday: formProps.saturday,
      sunday: formProps.sunday
    };

    this.props.updateContact(contactRequestData, id, lang, () => {
      this.props.history.push('/kontakt');
    });
  };

  render() {
    const { handleSubmit } = this.props;

    return (
      <div className="new-contact">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Field
            component={TextField}
            type="text"
            label="Email"
            name="email"
            validate={required}
          />
          <Field
            component={TextField}
            type="text"
            label="Telefon"
            name="telephone"
            validate={required}
          />
          <Field
            component={TextField}
            type="text"
            label="Telefon 2"
            name="telephone2"
            validate={required}
          />
          <div className="editor">
            <Field
              name="address"
              component={Editor}
              label="Adresa"
              validate={required}
            />
          </div>
          <div className="editor">
            <Field
              name="other"
              component={Editor}
              label="Další informace"
              validate={required}
            />
          </div>
          <div className="col-md-4">
            <h3>Otevírací doba</h3>
            <Field
              component={TextField}
              type="text"
              label="Pondělí"
              name="monday"
              validate={required}
            />
            <Field
              component={TextField}
              type="text"
              label="Úterý"
              name="tuesday"
              validate={required}
            />
            <Field
              component={TextField}
              type="text"
              label="Středa"
              name="wednesday"
              validate={required}
            />
            <Field
              component={TextField}
              type="text"
              label="Čtvrtek"
              name="thursday"
              validate={required}
            />
            <Field
              component={TextField}
              type="text"
              label="Pátek"
              name="friday"
              validate={required}
            />
            <Field
              component={TextField}
              type="text"
              label="Sobota"
              name="saturday"
              validate={required}
            />
            <Field
              component={TextField}
              type="text"
              label="Neděle"
              name="sunday"
              validate={required}
            />
          </div>
          <Field
            component={TextField}
            type="text"
            label="Title"
            name="title"
            validate={required}
          />
          <Field
            component={TextField}
            type="textarea"
            label="Meta description"
            name="description"
            validate={required}
          />
          <div className="form-buttons">
            <Button color="primary">Uložit</Button>
            <Button tag={Link} to="/kontakt" color="danger">
              Zpět
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = {
  saveContact,
  updateContact
};

export default compose(
  withRouter,
  connect(
    null,
    mapDispatchToProps
  ),
  reduxForm({ form: CONTACT_FORM_NAME })
)(ContactForm);



// WEBPACK FOOTER //
// ./src/modules/ContactForm/index.js